<script>
export default {
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        if (
          val.fullPath != "/" &&
          val.fullPath != "/error" &&
          val.fullPath != "/backoffice" &&
          val.fullPath != "/passworld" &&
          val.fullPath != "/tuto-respect" &&
          val.fullPath != "/presskit-one"
        ) {
          this.$store.commit("getInSpaceship");
        } else this.$store.commit("getOutSpaceship");
      },
    },
  },
  computed: {
    inSpaceship() {
      return this.$store.getters.inSpaceship;
    },
    wanerMsg() {
      return this.$store.getters.wanerMsg;
    },
  },
  beforeRouteEnter(to, from, next) {
    if (
      from !== "/error" &&
      from !== "/passworld" &&
      from !== "/" &&
      from !== "/spaceship" &&
      from !== "/backoffice"
    ) {
      if (
        this.$cookies.get("is_fellow") == null ||
        this.$cookies.get("is_god") == null
      ) {
        next("/");
      }
    }
  },
  methods: {
    checkScreenRatio(ratio) {
      if (
        (ratio <= 1.1 || ratio >= 2.2) &&
        window.screen.width > window.screen.height &&
        this.ratioOnce == false &&
        !this.isMobile()
      ) {
        this.menu = "ratio";
        return true;
      }
    },
    switchMenu() {
      if (this.ratioOnce == false && this.menu == "ratio") {
        this.ratioOnce = true;
        this.menu = null;
      }
      this.showGameMenu = !this.showGameMenu;
    },
    isMobile() {
      var hasTouchScreen = false;

      var mQ = window.matchMedia && matchMedia("(pointer:coarse)");
      if (mQ && mQ.media === "(pointer:coarse)") {
        hasTouchScreen = !mQ.matches;
        console.log("coucou3", hasTouchScreen);
      } else if ("orientation" in window) {
        hasTouchScreen = true; // deprecated, but good fallback
      } else {
        // Only as a last resort, fall back to user agent sniffing
        var UA = navigator.userAgent;
        hasTouchScreen =
          /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
          /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
        console.log("coucou4", hasTouchScreen);
      }

      if (/Mobi|Android/i.test(navigator.userAgent)) {
        hasTouchScreen = true;
      }
      return hasTouchScreen;
    },
    redirectToShip() {
      if (
        this.$route.path !== "/presskit-one" &&
        this.$route.path !== "/backoffice" &&
        !this.$store.getters.devMode
      )
        /*eslint-disable*/
        this.$router.push("/").catch((err) => {});
    },
    windowSizeListener() {
      var ratio = window.innerWidth / window.innerHeight;
      this.showGameMenu = this.checkScreenRatio(ratio);
    },
  },
  beforeCreate() {
    console.log("ship in ", process.env.NODE_ENV);
    if (process.env.NODE_ENV == "development")
      this.$store.commit("setToDevMode");
  },
  created() {},
  mounted() {
    if (this.isMobile()) this.$store.commit("setToMobile");
    this.redirectToShip();
    var ratio = window.innerWidth / window.innerHeight;
    window.addEventListener("resize", this.windowSizeListener);
    setTimeout(() => (this.showGameMenu = this.checkScreenRatio(ratio)), 1000);
    if (this.isMobile()) {
      window.onpagehide = window.onpageshow = window.onblur = () => {
        this.redirectToShip();
      };
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.windowSizeListener);
  },
};
</script>
